// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"111":"a19447f8","510":"b1bf910b","530":"e7531bf1","896":"8e93c5fc","907":"12cd28c0"}[chunkId] + ".chunk.css";
};